import tableAppBlackouts from './tableAppBlackouts';

export default {
  title: 'Room Blackouts',
  attributeName: 'appBlackouts',
  createURL: 'appId/appBlackouts',
  getURL: 'appId/appBlackouts',
  updateURL: 'appId/appBlackouts',
  updateURL: 'appId/appBlackoutsMultiple',
  removeURL: 'appId/appBlackouts',

  sessionParams: ['appId'],
  idAttribute: 'id',
  autoUpdate:true,
  noArea: true,
  // tabs: [tabAppTransactions, tabAppFailedTransactions],
  tableConfig: tableAppBlackouts,
  // initialTab: 'successful',
};
